import { actorSchema } from "@-/dev.improve.haniverse.database.schemas.actor.schema";
import { getTableName, is } from "@-/com.npmjs.drizzle-orm";
import { SQLiteTable } from "@-/com.npmjs.drizzle-orm/sqlite-core";
import onetime from "@-/com.npmjs.onetime";
import { installDatabaseReadGate } from "@-/dev.improve.haniverse.lib.database.change";

const getActorTableNames = onetime(() =>
  Object.values(actorSchema).flatMap((value) =>
    is(value, SQLiteTable) ? [getTableName(value)] : [],
  ),
);

/**
 * The longest the sign-in bootstrap may hold actor reads. The producer
 * (`markSignInForActorReset` in the sync client) releases on completion and bounds
 * itself at 60s; this is the gate's own fail-open guarantee above that, so the
 * producer's timer remains what normally releases it. Past it, held reads resolve
 * against whatever has synced — the same outcome as the producer's timeout.
 */
const ACTOR_READ_GATE_MAX_HOLD_MS = 90_000;

/**
 * Install a read gate over EVERY actor table: guarded reads that depend on any
 * actor table stay pending until the returned release function runs, while
 * content/static/device reads (disjoint table names) pass untouched.
 *
 * Used by the sign-in deck bootstrap (`markSignInForActorReset`) so screens
 * mounted between the actor-DB wipe and the account's initial remote pull hold
 * in their ordinary React Query loading state instead of resolving against the
 * momentarily-empty database.
 */
export function installActorReadGate({
  maxHoldMs = ACTOR_READ_GATE_MAX_HOLD_MS,
}: { maxHoldMs?: number } = {}): () => void {
  return installDatabaseReadGate(getActorTableNames(), {
    maxHoldMs,
    reason: "actor tables held for the sign-in bootstrap",
  });
}
